var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemStarOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12 5.877 10.751 8.35c-.512 1.015-1.446 1.724-2.528 1.92l-2.636.476 1.865 2.006a3.8 3.8 0 0 1 .965 3.106l-.38 2.768 2.4-1.234a3.4 3.4 0 0 1 3.125 0l2.402 1.234-.381-2.768a3.8 3.8 0 0 1 .965-3.106l1.865-2.006-2.636-.476c-1.082-.196-2.016-.905-2.528-1.92zm1.044-3.22a1.157 1.157 0 0 0-2.088 0L8.664 7.2c-.171.338-.482.575-.843.64l-4.84.875c-.936.17-1.307 1.364-.646 2.075l3.424 3.682c.255.274.374.657.322 1.035l-.7 5.083c-.134.981.838 1.72 1.69 1.282l4.408-2.265a1.13 1.13 0 0 1 1.042 0l4.409 2.265c.851.438 1.823-.3 1.688-1.282l-.699-5.083a1.27 1.27 0 0 1 .322-1.035l3.424-3.682c.661-.711.29-1.906-.645-2.075l-4.841-.875a1.19 1.19 0 0 1-.843-.64z",
  clipRule: "evenodd"
})));
export default SvgGemStarOutline;